export default {
  'coupon.error_code.E0009': 'This coupon has expired',
  'coupon.error_code.E0010': 'This coupon is fully claimed',
  'coupon.error_code.E0011': 'You have already claimed this coupon',
  'coupon.error_code.E0012': 'This coupon was already transferred. Please ask your friend to claim it.',
  'coupon.error_code.E0013': 'This coupon has expired and cannot be claimed',
  'coupon.error_code.E0014': 'The claim period has ended',
  'coupon.error_code.E0015': 'Sorry, your friend has cancelled the transfer',
  'coupon.error_code.E0016': 'Coupon data is invalid. Claim failed',
  'coupon.error_code.E0017': 'Insufficient points for redemption',
  'coupon.error_code.E0018': 'Point threshold is not met',
  'coupon.error_code.E0019': 'Sorry, your membership level does not meet the claim requirement.',
  'coupon.error_code.E0020': 'This coupon is past the claim period',
  'coupon.error_code.E0021': 'Failed to claim promotional points',
  'coupon.error_code.E0022': 'This coupon will be available from {start} to {end}',
  'coupon.error_code.E0023': 'This coupon was deleted',
  'coupon.error_code.E0024': 'Failed to issue coupon',
  'coupon.error_code.default': 'Failed to claim coupon',
  'coupon.collect.success.coupon': 'Coupon claimed',
  'coupon.collect.success.point': 'Points claimed',
} as Record<string, string>;
